import TemplateView from '../../../../TemplateView'
import {connect} from '../../../../redux/utils'
import {getCopyUserId, getPanelUserFirstName, isAssignAllScopeContentLoading} from '../selectors'
import {assignAllWorkAssignments} from '../actions'
import {bindActionCreators} from 'redux'
import messageResource from '../../../../messageResource'
import CounterWithProgressBar from '../../../../components/counterCPT/CounterWithProgressBar'
import {HierarchyLevels} from 'constants'
import {getViewerManagementCounters} from '../../common/selectors'
import SpinnerController from '../../../../SpinnerController'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../../util/pluralizeUtils'

/**
 * @author makovchik.
 * @since 14.08.2018.
 */
class AssignAllScopeContent extends TemplateView {
    constructor({
        onCopy = () => {},
        onCancel = () => {},
    } = {}) {
        super()

        this.params = {
            onCopy,
            onCancel,
        }

        this.state = {
            userFirstName: '',
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0,
            },
        }

        this.onStatePropertyChanged('userFirstName', (name) => {

            this.$title.text(messageResource.getMessage('work_assignments.panel.all.assignments.title', [name]))
            this.$subtitle.text(messageResource.getMessage('work_assignments.panel.all.assignments.subtitle', [name]))
        })

        this.onStatePropertyChanged('counters', (state) => {

            this.customerCounter.setState({
                curValue: state.customers,
                maxValue: state.customers,
                title: messageResource.getMessage('userlist.work_assignments.active') + " " + customerNameLower(state.customers),
                active: state.customers > 0,
                pale: state.customers === 0,
            })

            this.projectCounter.setState({
                curValue: state.projects,
                maxValue: state.projects,
                title: messageResource.getMessage('userlist.work_assignments.active') + " " + projectNameLower(state.projects),
                active: state.projects > 0,
                pale: state.projects === 0,
            })

            this.taskCounter.setState({
                curValue: state.tasks,
                maxValue: state.tasks,
                title: messageResource.getMessage('userlist.work_assignments.open') + " " + taskNameLower(state.tasks),
                active: state.tasks > 0,
                pale: state.tasks === 0,
            })
        })

        this.onStatePropertyChanged('loading', (loading) => {
            if (loading) {
                this.spinner.spinInElement(this.$spinner)
            } else {
                this.spinner.stop()
            }
        });
    }

    templateHtml() {
        return '<div class="copyContent">' +
               '  <div class="title"></div>' +
               '  <div class="subtitle"></div>' +
               '  <div class="spinner"/>' +
               '  <div class="counters">' +
               '    <div class="customers"></div>' +
               '    <div class="projects"></div>' +
               '    <div class="tasks"></div>' +
               '  </div>' +
               '  <div class="buttonsSection">' +
               '    <div class="copyButton"><%-accept%></div>' +
               '    <div class="cancelButton"><%-cancel%></div>' +
               '  </div>' +
               '</div>'
    }

    templateModel() {
        return {
            accept: messageResource.getMessage('common.assign'),
            cancel: messageResource.getMessage('common.cancel'),
        }
    }

    afterRender() {

        this.$copyButton = this.find('.copyButton')
        this.$cancelButton = this.find('.cancelButton')
        this.$title = this.find('.title')
        this.$subtitle = this.find('.subtitle')

        this.$cancelButton.click(() => {
            this.params.onCancel()
        })

        this.$copyButton.click(() => {
            this.params.onCopy()
        })

        this.$customerCounter = this.find('.counters .customers')
        this.customerCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
        }).init(this.$customerCounter)
        this.$projectCounter = this.find('.counters .projects')
        this.projectCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
        }).init(this.$projectCounter)
        this.$taskCounter = this.find('.counters .tasks')
        this.taskCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
        }).init(this.$taskCounter)

        this.$spinner = this.find('.spinner');
        this.spinner = new SpinnerController();

        this.renderInitialState()
    }
}

export default connect(
    state => ({
        userFirstName: getPanelUserFirstName(state),
        loading: isAssignAllScopeContentLoading(state),
        counters: getViewerManagementCounters(state),
    }),
    dispatch => ({
        onCopy: bindActionCreators(assignAllWorkAssignments, dispatch),
    })
)(AssignAllScopeContent)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/AssignAllScopeContent.js